import { api } from "@/service";
import type { TRegisterForm, TUser } from "@/types";
import { AxiosError } from "axios";

export class UserService {
   async getCurrentUser(slug: string) {
      return api
         .get<TUser>(`/workspaces/${slug}/users/me`)
         .then((response) => response.data)
         .catch((error: AxiosError) => {
            throw error.response?.data;
         });
   }
   async getUsers(slug: string) {
      return api
         .get<TUser[]>(`/workspaces/${slug}/users/`)
         .then((response) => response.data)
         .catch((error: AxiosError) => {
            throw error.response?.data;
         });
   }
   async createUser(slug: string, user: TRegisterForm) {
      return api
         .post<TUser>(`/workspaces/${slug}/users/`, user)
         .then((response) => response.data)
         .catch((error: AxiosError) => {
            throw error.response?.data;
         });
   }
   async updateUser(
      slug: string,
      userId: string,
      user: Partial<TUser & { removeImage: boolean }> | { photo: File },
   ) {
      return api["photo" in user ? "patchForm" : "patch"]<TUser>(
         `/workspaces/${slug}/users/${userId}`,
         user,
      )
         .then((response) => response.data)
         .catch((error: AxiosError) => {
            throw error.response?.data;
         });
   }
}
